import { render } from "./BlogDetails.vue?vue&type=template&id=3e16285c"
import script from "../js/blog-details.js?vue&type=script&lang=js&external"
export * from "../js/blog-details.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__